(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-description"] && !Shopify.designMode) return;
  try {
    class ProductDescription extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.product-description__content');
      this.toggle = this.querySelector('.product-description__toggle');
      if (!this.content || !this.toggle) return;

      this.toggle.addEventListener('click', this.onToggle);
      this.content.addEventListener('transitionend', this.onTransitionEnd);
      this.content.addEventListener('focusin', this.onFocusIn);

      // Font swaps and width changes both resize the clamped box, so this also
      // re-checks after the web font arrives.
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.content);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.toggle?.removeEventListener('click', this.onToggle);
      this.content?.removeEventListener('transitionend', this.onTransitionEnd);
      this.content?.removeEventListener('focusin', this.onFocusIn);
    }

    get expanded() {
      return this.hasAttribute('data-expanded');
    }

    measure() {
      if (this.expanded) return;
      const overflowing = this.content.scrollHeight > this.content.clientHeight + 1;
      this.toggleAttribute('data-overflowing', overflowing);
      this.toggle.hidden = !overflowing;
    }

    onToggle = () => {
      const expanding = !this.expanded;
      const from = this.content.offsetHeight;

      this.content.style.height = '';
      this.toggleAttribute('data-expanded', expanding);
      this.toggle.setAttribute('aria-expanded', String(expanding));
      const to = this.content.offsetHeight;

      // Collapsing from far down the text would leave the reader stranded
      // below it, so bring the description back into view instead of animating.
      if (!expanding && this.getBoundingClientRect().top < 0) {
        this.scrollIntoView({ block: 'start' });
        return;
      }

      if (from === to || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.content.style.height = `${from}px`;
      this.content.offsetHeight;
      this.content.style.height = `${to}px`;
    };

    // A link in the clipped part of the text can still take keyboard focus,
    // which would scroll the clamped box under the reader or focus something
    // they can't see. Open the text instead, at once.
    onFocusIn = () => {
      if (this.expanded || !this.hasAttribute('data-overflowing')) return;
      this.content.scrollTop = 0;
      this.setAttribute('data-expanded', '');
      this.toggle.setAttribute('aria-expanded', 'true');
    };

    onTransitionEnd = (event) => {
      if (event.target === this.content && event.propertyName === 'height') {
        this.content.style.height = '';
      }
    };
  }

  if (!customElements.get('product-description')) {
    customElements.define('product-description', ProductDescription);
  }
  } catch(e) { console.error(e); }
})();

})();
